import { useParams } from 'react-router-dom';
import './ActiveAccount.scss';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { activateAccount } from '../../store/actions/auth.action';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import ROUTER from '../../routers/Routers';
import { openMessageSuccess } from '../../components/common/Message/openMessageSuccess';
import { openMessageWarning } from '../../components/common/Message/openMessageWarning';
import { useTranslation } from 'react-i18next';

const ActiveAccount = () => {
  const { token } = useParams();
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(activateAccount({ token })).then(action => {
      if (action.payload?.data) {
        const { data } = action.payload;
        openMessageSuccess({ content: t('Account activated successfully') });
        openMessageWarning({
          content: t('Warning.login_to_add_cart'),
        });
        navigate('/');
      } else navigate(ROUTER.LINK_EXPIRED);
    });
  });
  return (
    <div className="flex items-center justify-center">
      <h2>{t('Activating account')}</h2>
    </div>
  );
};

export default ActiveAccount;
